import { Routes, Route } from 'react-router-dom';
import PrivateRoute from '../components/common/PrivateRoute';
import ChecklistLayout from '../components/Products/Checklist/components/Layout.jsx';
import Dashboard from '../components/Products/Checklist/pages/Dashboard.jsx';
import ModelosPage from '../components/Products/Checklist/pages/ModelosPage.jsx';
import ModeloForm from '../components/Products/Checklist/pages/ModeloForm.jsx';
import AplicarChecklistPage from '../components/Products/Checklist/pages/ExecucoesPage.jsx';
import ExecucoesListPage from '../components/Products/Checklist/pages/ExecucoesListPage.jsx'; // Componente da nova página
import ExecucaoForm from '../components/Products/Checklist/pages/ExecucaoForm.jsx';
import ExecucaoDetalhesPage from '../components/Products/Checklist/pages/ExecucaoDetalhesPage.jsx';
import PlanosPage from '../components/Products/Checklist/pages/PlanosPage.jsx';
import AgendamentosPage from '../components/Products/Checklist/pages/AgendamentosPage.jsx';
import IaPage from '../components/Products/Checklist/pages/IaPage.jsx';
import ConfigPage from '../components/Products/Checklist/pages/ConfigPage.jsx';

const ChecklistRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute product="checklist">
            <ChecklistLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route
          path="modelos"
          element={
            <PrivateRoute ownerOnly allowCheflistAdmin product="checklist">
              <ModelosPage />
            </PrivateRoute>
          }
        />
        <Route
          path="modelos/novo"
          element={
            <PrivateRoute ownerOnly allowCheflistAdmin product="checklist">
              <ModeloForm />
            </PrivateRoute>
          }
        />
        <Route
          path="modelos/:id"
          element={
            <PrivateRoute ownerOnly allowCheflistAdmin product="checklist">
              <ModeloForm />
            </PrivateRoute>
          }
        />
        
        {/* Rota para iniciar um NOVO checklist */}
        <Route path="aplicar" element={<AplicarChecklistPage />} />
        
        {/* Rota para ver a LISTA de execuções (e continuar as pendentes) */}
        <Route
          path="execucoes"
          element={
            <PrivateRoute ownerOnly allowCheflistAdmin product="checklist">
              <ExecucoesListPage />
            </PrivateRoute>
          }
        />

        {/* Rota para a página de preenchimento de um checklist específico */}
        <Route
          path="execucoes/:id"
          element={
            <PrivateRoute ownerOnly allowCheflistAdmin product="checklist">
              <ExecucaoForm />
            </PrivateRoute>
          }
        />
        {/* Visualização de uma execução concluída */}
        <Route
          path="execucoes/:id/detalhes"
          element={
            <PrivateRoute ownerOnly allowCheflistAdmin product="checklist">
              <ExecucaoDetalhesPage />
            </PrivateRoute>
          }
        />
        
        <Route path="planos" element={<PlanosPage />} />
        <Route path="agendamentos" element={<AgendamentosPage />} />
        <Route path="ia" element={<IaPage />} />
        <Route path="config" element={<ConfigPage />} />
      </Route>
    </Routes>
  );
};

export default ChecklistRoutes;
